import { Text } from 'blaze-ui/Text/Text'
import dayjs from 'dayjs'
import Styles from './ReviewerCard.module.scss'
import { NotOpened, Viewed } from 'blaze-ui/icons/20'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const LastViewed = ({ lastViewed }: { lastViewed: string }) => {
  const { isMobile } = useResponsiveDesign()
  const label = isMobile
    ? `Viewed ${dayjs(lastViewed).format('MMM D')}`
    : `Viewed on ${dayjs(lastViewed).format('MMM D YYYY')}`

  return (
    <div className={Styles.reviewResult}>
      {lastViewed ? <Viewed /> : <NotOpened />}
      <Text variant="label" color="var(--dark-60)">
        {lastViewed ? label : 'Not opened'}
      </Text>
    </div>
  )
}
